import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RegionService } from '../../services/region.service';

@Component({
  selector: 'welcome-page',
  templateUrl: 'welcome.html'
})
export class WelcomePage {

  constructor(
    private router: Router,
    public regionService: RegionService
  ) { }

  prev(): void {
    this.router.navigate(['home']);
  }

  next(): void {
    this.router.navigate(['visual-challenges']);
  }

}



// WEBPACK FOOTER //
// ./src/pages/welcome/welcome.ts